import React from 'react';
import { Outlet,Navigate } from 'react-router-dom';
import Cookies from "universal-cookie";


const cookies = new Cookies();
// Replace this with your real authentication logic
const isAuthenticated = () => {

  // Check if token exists in cookies
  return !!cookies.get("token");
};
const ProtectedRoute = () => {
  if (!isAuthenticated()) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }
  // Render nested protected routes
  return <Outlet />;
};


export default ProtectedRoute;
